module.exports = __webpack_public_path__ + "static/media/hyu_erica_logo.7e5066f2.png";